module.exports = __webpack_public_path__ + "static/media/coal.81c72790.jpg";